var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Button, Checkbox, Heading2, Input, Textarea, } from "@stellar/design-system";
import { BUSINESS_SERVER_ENDPOINT } from "App";
import { capture } from "lib/analytics";
import { ROZO_EVENTS } from "lib/analytics/events";
import { useEffect, useMemo, useRef, useState } from "react";
import { isAddress } from "viem";
import { getAssetByCode, getAssetDisplayLabel, getAssetDisplaySubtitle, isUsdt0Code, parseAssetCode, USDT0_CHAINS, USDT0_MAX_AMOUNT, USDT0_MAX_DECIMALS, } from "../const";
import { isEvmAddress, isSolanaWalletAddress } from "../helpers/address";
import { checkTrustline } from "../helpers/checkTrustline";
import { formatAmountInput, parseAmount, trimInsignificantAmountZeros, validateAmount, } from "../helpers/amount";
import { fetchFee } from "../helpers/fetchFee";
import { Ethereum, Solana } from "../components/chains";
var FEE_QUOTE_DEBOUNCE_MS = 400;
export var EXACT_OUT_UNSUPPORTED_MESSAGE = "USDT supports a fixed send amount only. Receive-exact (exact_out) is not supported yet. Start again without it.";
export var Kyc = function (_a) {
    var _b, _c, _d, _e, _f;
    var sessionToken = _a.sessionToken, type = _a.type, account = _a.account, withdrawAmount = _a.withdrawAmount, initialFeeMode = _a.initialFeeMode, _g = _a.isFeeModeLocked, isFeeModeLocked = _g === void 0 ? false : _g, _h = _a.assetCode, assetCode = _h === void 0 ? "USDC" : _h, callback = _a.callback;
    var asset = parseAssetCode(assetCode) || "USDC";
    // On-chain code, used for the trustline check, fee quote and analytics.
    var assetCodeUpper = asset.toUpperCase();
    var assetLabel = getAssetDisplayLabel(assetCodeUpper);
    var assetSubtitle = getAssetDisplaySubtitle(assetCodeUpper);
    var isUsdt0 = isUsdt0Code(assetCodeUpper);
    // Unknown asset codes are an error, never a silent USDC fallback.
    var assetResolution = useMemo(function () {
        try {
            return { asset: getAssetByCode(assetCodeUpper), error: "" };
        }
        catch (error) {
            return {
                asset: null,
                error: error instanceof Error ? error.message : "Unsupported asset code.",
            };
        }
    }, [assetCodeUpper]);
    var unsupportedAssetError = assetResolution.error;
    // USDT0 rules: exact_in only, at most 2 decimals, 1,000 per transaction.
    var amountRules = isUsdt0
        ? { maxDecimals: USDT0_MAX_DECIMALS, maxAmount: USDT0_MAX_AMOUNT }
        : {};
    var isExactOutUnsupported = isUsdt0 && initialFeeMode === "exact_out";
    var _j = useState({
        deposit: {
            amount: "",
            email: "",
        },
        withdrawal: {
            amount: "",
            email: "",
            account: "",
        },
    }), kycFields = _j[0], setKycFields = _j[1];
    var _k = useState({}), errors = _k[0], setErrors = _k[1];
    var _l = useState(""), submitError = _l[0], setSubmitError = _l[1];
    // USDT0 only: Ethereum or Solana (deposit source / withdrawal destination).
    var _m = useState(""), usdt0Chain = _m[0], setUsdt0Chain = _m[1];
    var _o = useState(false), isSubmitting = _o[0], setIsSubmitting = _o[1];
    // Unchecked (default) = exact_in: the entered amount is what the user sends.
    // Checked = exact_out: the entered amount is what the recipient receives.
    var _p = useState(!isUsdt0 && initialFeeMode === "exact_out"), coverFee = _p[0], setCoverFee = _p[1];
    var _q = useState(), feeQuote = _q[0], setFeeQuote = _q[1];
    var _r = useState(false), feeLoading = _r[0], setFeeLoading = _r[1];
    var _s = useState(false), feeDebouncing = _s[0], setFeeDebouncing = _s[1];
    var _t = useState(null), debouncedFeeRequest = _t[0], setDebouncedFeeRequest = _t[1];
    var _u = useState(""), feeError = _u[0], setFeeError = _u[1];
    var _v = useState({
        loading: false,
        exists: null,
        balance: "0",
        error: "",
    }), trustlineStatus = _v[0], setTrustlineStatus = _v[1];
    var trustlineCheckRequestId = useRef(0);
    var formViewedRef = useRef(false);
    var feeModeAdoptedRef = useRef(false);
    var formatBalance = function (value) {
        var parsed = Number(value);
        if (!Number.isFinite(parsed))
            return value;
        return new Intl.NumberFormat("en-US", {
            minimumFractionDigits: 0,
            maximumFractionDigits: 7,
        }).format(parsed);
    };
    useEffect(function () {
        if (withdrawAmount && Number(parseAmount(withdrawAmount)) > 0) {
            var displayAmount_1 = trimInsignificantAmountZeros(withdrawAmount);
            setKycFields(function (prev) { return (__assign(__assign({}, prev), { withdrawal: __assign(__assign({}, prev.withdrawal), { amount: displayAmount_1 }) })); });
        }
    }, [withdrawAmount]);
    // The transaction is fetched after this form mounts, so adopt the fee mode
    // the wallet already requested as soon as it arrives. Applied once: the
    // checkbox stays editable afterwards.
    useEffect(function () {
        if (!initialFeeMode || feeModeAdoptedRef.current)
            return;
        feeModeAdoptedRef.current = true;
        // USDT0 is exact_in only; an exact_out request is refused below instead.
        setCoverFee(!isUsdt0 && initialFeeMode === "exact_out");
    }, [initialFeeMode, isUsdt0]);
    // KYC form viewed (fires once per mount, after type is known)
    useEffect(function () {
        if (!type || formViewedRef.current)
            return;
        formViewedRef.current = true;
        capture(ROZO_EVENTS.KYC_FORM_VIEWED, {
            transaction_kind: type,
            asset_code: assetCodeUpper,
        });
    }, [type]);
    // Check asset trustline/balance using the user's Stellar account
    useEffect(function () {
        var stellarAsset = assetResolution.asset;
        if (!type || !account || !stellarAsset)
            return;
        var requestId = ++trustlineCheckRequestId.current;
        var cancelled = false;
        var runCheck = function () { return __awaiter(void 0, void 0, void 0, function () {
            var result, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setTrustlineStatus(function (prev) { return (__assign(__assign({}, prev), { loading: true, exists: null, error: "" })); });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, checkTrustline(account, stellarAsset)];
                    case 2:
                        result = _a.sent();
                        if (cancelled || requestId !== trustlineCheckRequestId.current)
                            return [2 /*return*/];
                        setTrustlineStatus({
                            loading: false,
                            exists: result.exists,
                            balance: result.balance,
                            error: "",
                        });
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        if (cancelled || requestId !== trustlineCheckRequestId.current)
                            return [2 /*return*/];
                        setTrustlineStatus({
                            loading: false,
                            exists: false,
                            balance: "0",
                            error: error_1 instanceof Error
                                ? error_1.message
                                : "Failed to check trustline",
                        });
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        runCheck();
        return function () {
            cancelled = true;
        };
    }, [type, account, assetResolution.asset]);
    var feeOperation = type !== null && type !== void 0 ? type : "withdrawal";
    var feeMode = coverFee && !isUsdt0 ? "exact_out" : "exact_in";
    var currentAmountRaw = parseAmount((_c = (_b = kycFields[type || "deposit"]) === null || _b === void 0 ? void 0 : _b.amount) !== null && _c !== void 0 ? _c : "");
    var isAmountQuotable = Boolean(type) &&
        !unsupportedAssetError &&
        !isExactOutUnsupported &&
        !validateAmount(currentAmountRaw, amountRules);
    // Debounce typing/toggling before calculating a fee for the settled inputs.
    useEffect(function () {
        if (!sessionToken || !isAmountQuotable) {
            setDebouncedFeeRequest(null);
            setFeeQuote(undefined);
            setFeeError("");
            setFeeLoading(false);
            setFeeDebouncing(false);
            return;
        }
        // Drop the previous quote immediately: it describes a different amount or
        // fee mode and must not stay on screen through the debounce + fetch.
        setDebouncedFeeRequest(null);
        setFeeQuote(undefined);
        setFeeError("");
        setFeeLoading(false);
        setFeeDebouncing(true);
        var timer = setTimeout(function () {
            setDebouncedFeeRequest({ amount: currentAmountRaw, feeMode: feeMode });
        }, FEE_QUOTE_DEBOUNCE_MS);
        return function () {
            clearTimeout(timer);
        };
    }, [sessionToken, currentAmountRaw, feeMode, isAmountQuotable]);
    // Live fee breakdown for the debounced amount + fee mode.
    useEffect(function () {
        if (!sessionToken || !isAmountQuotable || !debouncedFeeRequest) {
            return;
        }
        var controller = new AbortController();
        setFeeLoading(true);
        setFeeDebouncing(false);
        setFeeError("");
        fetchFee({
            sessionToken: sessionToken,
            assetCode: assetCodeUpper,
            amount: debouncedFeeRequest.amount,
            feeMode: debouncedFeeRequest.feeMode,
            operation: feeOperation,
            signal: controller.signal,
        })
            .then(function (quote) {
            if (controller.signal.aborted)
                return;
            setFeeQuote(quote);
            setFeeLoading(false);
        })
            .catch(function (error) {
            if (controller.signal.aborted)
                return;
            setFeeQuote(undefined);
            setFeeError(error instanceof Error
                ? error.message
                : "Could not load the fee breakdown.");
            setFeeLoading(false);
        });
        return function () {
            controller.abort();
        };
    }, [
        sessionToken,
        assetCodeUpper,
        feeOperation,
        debouncedFeeRequest,
        isAmountQuotable,
    ]);
    var isFeeQuotePending = feeDebouncing || feeLoading;
    var renderFeeSection = function () { return (_jsxs("div", { className: "FeeSection", children: [isUsdt0 ? null : (_jsx(Checkbox, { id: "cover-fee", name: "cover-fee", label: "I will cover the fee (recipient receives the exact amount)", note: isFeeModeLocked
                    ? "Fee mode was set by your wallet"
                    : coverFee
                        ? "You will pay the amount plus fees; the recipient receives exactly what you enter."
                        : undefined, checked: coverFee, disabled: isFeeModeLocked || feeLoading, onChange: function (e) {
                    if (feeLoading)
                        return;
                    setCoverFee(e.target.checked);
                } })), isAmountQuotable && (_jsxs("div", { className: "FeeBreakdown", "aria-live": "polite", children: [isFeeQuotePending && (_jsx("div", { className: "FeeBreakdown__status", children: "Calculating fee\u2026" })), feeError && !isFeeQuotePending && (_jsx("div", { className: "FeeBreakdown__status FeeBreakdown__status--error", children: feeError })), feeQuote && (_jsxs(_Fragment, { children: [_jsxs("div", { className: "FeeBreakdown__row", children: [_jsx("span", { children: "You pay" }), _jsxs("strong", { children: [trimInsignificantAmountZeros(feeQuote.amount_in), " ", assetLabel] })] }), _jsxs("div", { className: "FeeBreakdown__row", children: [_jsx("span", { children: "Fee" }), _jsxs("strong", { children: [trimInsignificantAmountZeros(feeQuote.amount_fee), " ", assetLabel] })] }), _jsxs("div", { className: "FeeBreakdown__row", children: [_jsx("span", { children: "Recipient receives" }), _jsxs("strong", { children: [trimInsignificantAmountZeros(feeQuote.amount_out), " ", assetLabel] })] })] }))] }))] })); };
    var selectedUsdt0Chain = USDT0_CHAINS.find(function (c) { return c.key === usdt0Chain; });
    var trustlineMissingMessage = isUsdt0
        ? "USDT0 trustline not found. Add USDT0 on Stellar to your wallet first, then start the deposit again."
        : "".concat(assetLabel, " trustline not found. Please add ").concat(assetLabel, " trustline to your account before depositing.");
    var renderAssetSubtitle = function () {
        return assetSubtitle ? (_jsx("div", { className: "KycAssetSubtitle", style: { textAlign: "center" }, children: assetSubtitle })) : null;
    };
    var renderUsdt0ChainPicker = function () {
        if (!isUsdt0)
            return null;
        var legend = type === "deposit" ? "Pay from chain" : "Receive on chain";
        return (_jsxs("fieldset", { className: "ChainPicker", style: { border: 0, padding: 0 }, children: [_jsx("legend", { style: { marginBottom: 8, fontWeight: 500 }, children: legend }), _jsx("div", { style: { display: "flex", gap: 8 }, role: "radiogroup", children: USDT0_CHAINS.map(function (chain) {
                        var selected = usdt0Chain === chain.key;
                        return (_jsxs("button", { type: "button", role: "radio", "aria-checked": selected, onClick: function () {
                                setUsdt0Chain(chain.key);
                                setSubmitError("");
                                // Re-validate the address against the newly chosen chain.
                                setErrors(function (prev) { return (__assign(__assign({}, prev), { account: undefined })); });
                            }, style: {
                                flex: 1,
                                padding: "10px 12px",
                                borderRadius: 8,
                                border: selected ? "2px solid #0a0a0a" : "1px solid #dee2e6",
                                backgroundColor: selected ? "#0a0a0a" : "#fff",
                                color: selected ? "#fff" : "#0a0a0a",
                                cursor: "pointer",
                                fontWeight: selected ? 600 : 400,
                                display: "inline-flex",
                                alignItems: "center",
                                justifyContent: "center",
                                gap: 8,
                            }, children: [chain.key === "ethereum" ? (_jsx(Ethereum, { width: 20, height: 20 })) : (_jsx(Solana, { width: 20, height: 20 })), chain.label] }, chain.key));
                    }) })] }));
    };
    var renderUsdt0Limits = function () {
        return isUsdt0 ? (_jsxs("div", { style: { fontSize: 13, color: "#6c757d", width: "100%" }, children: ["Up to ", USDT0_MAX_AMOUNT.toLocaleString("en-US"), " ", assetLabel, " per transaction, at most ", USDT0_MAX_DECIMALS, " decimal places."] })) : null;
    };
    var destinationLabel = isUsdt0
        ? "".concat((_d = selectedUsdt0Chain === null || selectedUsdt0Chain === void 0 ? void 0 : selectedUsdt0Chain.label) !== null && _d !== void 0 ? _d : "Destination", " Address")
        : "Base Address";
    /** Error for a withdrawal destination address, or undefined when valid. */
    var getAccountError = function (value) {
        if (!value)
            return undefined;
        if (!isUsdt0) {
            return isAddress(value) ? undefined : "Invalid Base address";
        }
        if (usdt0Chain === "ethereum") {
            return isEvmAddress(value) ? undefined : "Invalid Ethereum address";
        }
        if (usdt0Chain === "solana") {
            return isSolanaWalletAddress(value)
                ? undefined
                : "Invalid Solana wallet address";
        }
        return "Choose Ethereum or Solana first";
    };
    // TODO: update any type
    var handleChangeValue = function (e) {
        if (!type) {
            return;
        }
        var _a = e.target, name = _a.name, value = _a.value;
        // Clear error when user starts typing
        if (errors[name]) {
            setErrors(function (prev) {
                var _a;
                return (__assign(__assign({}, prev), (_a = {}, _a[name] = undefined, _a)));
            });
        }
        // Special handling for amount field
        if (name === "amount") {
            var formatted_1 = formatAmountInput(value);
            setKycFields(function (prevState) {
                var _a, _b;
                return (_a = {},
                    _a[type] = __assign(__assign({}, prevState[type]), (_b = {}, _b[name] = formatted_1, _b)),
                    _a);
            });
        }
        else {
            setKycFields(function (prevState) {
                var _a, _b;
                return (_a = {},
                    _a[type] = __assign(__assign({}, prevState[type]), (_b = {}, _b[name] = value, _b)),
                    _a);
            });
        }
    };
    // TODO: update any type
    var handleBlur = function (e) {
        if (!type) {
            return;
        }
        var _a = e.target, name = _a.name, value = _a.value;
        // Validate amount on blur (string-based, so 6-decimal input is preserved)
        if (name === "amount" && value) {
            var amountError_1 = validateAmount(value, amountRules);
            if (amountError_1) {
                setErrors(function (prev) { return (__assign(__assign({}, prev), { amount: amountError_1 })); });
            }
        }
        // Validate address on blur
        if (name === "account" && value) {
            var accountError_1 = getAccountError(value);
            if (accountError_1) {
                setErrors(function (prev) { return (__assign(__assign({}, prev), { account: accountError_1 })); });
            }
        }
    };
    // TODO: update any type
    var handleSubmitKyc = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var currentFields, amountError, withdrawalFields, accountError, submitData, response, errorData, submitResponse, nextSessionToken, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    e.preventDefault();
                    if (!type) {
                        return [2 /*return*/];
                    }
                    // Clear previous errors
                    setErrors({});
                    setSubmitError("");
                    currentFields = kycFields[type];
                    if (!currentFields) {
                        return [2 /*return*/];
                    }
                    if (unsupportedAssetError) {
                        setSubmitError(unsupportedAssetError);
                        return [2 /*return*/];
                    }
                    if (isExactOutUnsupported) {
                        setSubmitError(EXACT_OUT_UNSUPPORTED_MESSAGE);
                        return [2 /*return*/];
                    }
                    if (isUsdt0 && !usdt0Chain) {
                        setSubmitError(type === "deposit"
                            ? "Choose the chain you will pay from: Ethereum or Solana."
                            : "Choose the chain to receive on: Ethereum or Solana.");
                        capture(ROZO_EVENTS.KYC_VALIDATION_FAILED, {
                            transaction_kind: type,
                            error_field: "chain",
                        });
                        return [2 /*return*/];
                    }
                    amountError = validateAmount(currentFields.amount, amountRules);
                    if (amountError) {
                        setErrors({ amount: amountError });
                        capture(ROZO_EVENTS.KYC_VALIDATION_FAILED, {
                            transaction_kind: type,
                            error_field: "amount",
                        });
                        return [2 /*return*/];
                    }
                    // Validate Base address for withdrawal
                    if (type === "withdrawal") {
                        withdrawalFields = currentFields;
                        accountError = isUsdt0
                            ? withdrawalFields.account
                                ? getAccountError(withdrawalFields.account)
                                : "".concat(destinationLabel, " is required")
                            : getAccountError(withdrawalFields.account);
                        if (accountError) {
                            setErrors({ account: accountError });
                            capture(ROZO_EVENTS.KYC_VALIDATION_FAILED, {
                                transaction_kind: type,
                                error_field: "account",
                            });
                            return [2 /*return*/];
                        }
                    }
                    // Validate asset trustline for deposit
                    if (type === "deposit" && !trustlineStatus.exists) {
                        setSubmitError(trustlineMissingMessage);
                        capture(ROZO_EVENTS.KYC_VALIDATION_FAILED, {
                            transaction_kind: type,
                            error_field: "trustline",
                        });
                        return [2 /*return*/];
                    }
                    setIsSubmitting(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 7, 8, 9]);
                    submitData = __assign(__assign(__assign(__assign(__assign({}, currentFields), { amount: parseAmount(currentFields.amount) }), (type === "deposit" || feeMode === "exact_out" || isUsdt0
                        ? { fee_mode: feeMode }
                        : {})), (isUsdt0 && type === "deposit" ? { source_chain: usdt0Chain } : {})), (isUsdt0 && type === "withdrawal"
                        ? { destination_chain: usdt0Chain }
                        : {}));
                    return [4 /*yield*/, fetch("".concat(BUSINESS_SERVER_ENDPOINT, "/submit"), {
                            method: "POST",
                            headers: {
                                Authorization: "Bearer ".concat(sessionToken),
                                "Content-Type": "application/json",
                            },
                            body: JSON.stringify(submitData),
                        })];
                case 2:
                    response = _a.sent();
                    if (!!response.ok) return [3 /*break*/, 4];
                    return [4 /*yield*/, response.json().catch(function () { return ({}); })];
                case 3:
                    errorData = _a.sent();
                    throw new Error(errorData.message ||
                        errorData.error ||
                        "Server error: ".concat(response.status, " ").concat(response.statusText));
                case 4: return [4 /*yield*/, response.json().catch(function () { return ({}); })];
                case 5:
                    submitResponse = (_a.sent());
                    nextSessionToken = submitResponse.sessionId || submitResponse.session_id;
                    if (!nextSessionToken) {
                        throw new Error("Submission succeeded but no session id returned.");
                    }
                    capture(ROZO_EVENTS.PAYMENT_SUBMITTED, __assign({ transaction_kind: type, amount: parseAmount(currentFields.amount), token_symbol: assetCodeUpper }, (type === "deposit" || feeMode === "exact_out"
                        ? { fee_mode: feeMode }
                        : {})));
                    return [4 /*yield*/, callback(nextSessionToken, type === "withdrawal")];
                case 6:
                    _a.sent();
                    return [3 /*break*/, 9];
                case 7:
                    e_1 = _a.sent();
                    console.error("Submission error:", e_1);
                    setSubmitError(e_1.message ||
                        "Failed to submit. Please check your connection and try again.");
                    capture(ROZO_EVENTS.PAYMENT_FAILED, {
                        transaction_kind: type,
                        error_message: (e_1 === null || e_1 === void 0 ? void 0 : e_1.message) || "Submission failed",
                    });
                    return [3 /*break*/, 9];
                case 8:
                    setIsSubmitting(false);
                    return [7 /*endfinally*/];
                case 9: return [2 /*return*/];
            }
        });
    }); };
    var renderDepositFields = function () {
        var _a, _b;
        return (_jsxs(_Fragment, { children: [_jsx(Heading2, { style: { textAlign: "center" }, children: "Deposit" }), renderAssetSubtitle(), _jsx(Textarea, { label: "Account", id: "account", name: "account", value: account || "", readOnly: true, disabled: true }), trustlineStatus.loading && (_jsxs("div", { style: {
                        padding: "12px 16px",
                        backgroundColor: "#e7f3ff",
                        color: "#004085",
                        borderRadius: "4px",
                        border: "1px solid #b8daff",
                        width: "100%",
                    }, children: ["Checking ", assetLabel, " trustline..."] })), !trustlineStatus.loading && trustlineStatus.error && (_jsxs("div", { style: {
                        padding: "12px 16px",
                        backgroundColor: "#fff3cd",
                        color: "#856404",
                        borderRadius: "4px",
                        border: "1px solid #ffeaa7",
                        width: "100%",
                    }, children: ["\u26A0\uFE0F ", trustlineStatus.error] })), !trustlineStatus.loading &&
                    !trustlineStatus.error &&
                    trustlineStatus.exists && (_jsxs("div", { style: {
                        padding: "12px 16px",
                        backgroundColor: "#d4edda",
                        color: "#155724",
                        borderRadius: "4px",
                        border: "1px solid #c3e6cb",
                        width: "100%",
                    }, children: ["\u2713 ", assetLabel, " trustline exists."] })), !trustlineStatus.loading &&
                    !trustlineStatus.error &&
                    !trustlineStatus.exists && (_jsxs("div", { style: {
                        padding: "12px 16px",
                        backgroundColor: "#f8d7da",
                        color: "#721c24",
                        borderRadius: "4px",
                        border: "1px solid #f5c6cb",
                        width: "100%",
                    }, children: ["\u2717 ", trustlineMissingMessage] })), renderUsdt0ChainPicker(), _jsx(Input, { label: "".concat(assetLabel, " Amount"), id: "amount", name: "amount", inputMode: "decimal", placeholder: "e.g. 100", value: ((_a = kycFields.deposit) === null || _a === void 0 ? void 0 : _a.amount) || "", onChange: handleChangeValue, onBlur: handleBlur, error: errors.amount, required: true }), renderUsdt0Limits(), renderFeeSection(), _jsx(Input, { label: "Email (optional)", id: "email", name: "email", type: "email", placeholder: "your@email.com", value: ((_b = kycFields.deposit) === null || _b === void 0 ? void 0 : _b.email) || "", onChange: handleChangeValue })] }));
    };
    var renderWithdrawFields = function () {
        var _a, _b, _c;
        return (_jsxs(_Fragment, { children: [_jsx(Heading2, { style: { textAlign: "center" }, children: "Withdrawal" }), renderAssetSubtitle(), trustlineStatus.loading && (_jsxs("div", { style: {
                        padding: "12px 16px",
                        backgroundColor: "#e7f3ff",
                        color: "#004085",
                        borderRadius: "4px",
                        border: "1px solid #b8daff",
                        width: "100%",
                    }, children: ["Checking available ", assetLabel, " balance..."] })), !trustlineStatus.loading && trustlineStatus.error && (_jsx("div", { style: {
                        padding: "12px 16px",
                        backgroundColor: "#fff3cd",
                        color: "#856404",
                        borderRadius: "4px",
                        border: "1px solid #ffeaa7",
                        width: "100%",
                    }, children: trustlineStatus.error })), !trustlineStatus.loading && !trustlineStatus.error && (_jsxs("div", { style: {
                        padding: "12px 16px",
                        backgroundColor: "#f8f9fa",
                        color: "#212529",
                        borderRadius: "4px",
                        border: "1px solid #dee2e6",
                        width: "100%",
                    }, children: ["Available balance:", " ", _jsxs("strong", { children: [formatBalance(trustlineStatus.exists ? trustlineStatus.balance : "0"), " ", assetLabel] })] })), _jsx(Input, { label: "".concat(assetLabel, " Amount"), id: "amount", name: "amount", inputMode: "decimal", placeholder: isUsdt0 ? "e.g. 100.25" : "e.g. 100.123456", value: ((_a = kycFields.withdrawal) === null || _a === void 0 ? void 0 : _a.amount) || "", onChange: handleChangeValue, onBlur: handleBlur, error: errors.amount, disabled: Number(parseAmount(withdrawAmount || "0")) > 0, required: true }), renderUsdt0Limits(), renderFeeSection(), renderUsdt0ChainPicker(), _jsx(Textarea, { label: destinationLabel, id: "account", name: "account", placeholder: usdt0Chain === "solana" ? "Solana address" : "0x...", value: ((_b = kycFields.withdrawal) === null || _b === void 0 ? void 0 : _b.account) || "", onChange: handleChangeValue, onBlur: handleBlur, error: errors.account, required: true }), _jsx(Input, { label: "Email (optional)", id: "email", name: "email", type: "email", placeholder: "your@email.com", value: ((_c = kycFields.withdrawal) === null || _c === void 0 ? void 0 : _c.email) || "", onChange: handleChangeValue })] }));
    };
    if (!type) {
        return (_jsxs("div", { className: "KycBootstrapLoader", role: "status", "aria-live": "polite", children: [_jsx("div", { className: "KycBootstrapLoader__spinner", "aria-hidden": true }), _jsx("h3", { className: "KycBootstrapLoader__title", children: "Preparing KYC" })] }));
    }
    // Compute disabled state for submit button
    var isDepositDisabled = type === "deposit" &&
        (isFeeQuotePending || trustlineStatus.loading || !trustlineStatus.exists);
    var isWithdrawalDisabled = type === "withdrawal" &&
        (isFeeQuotePending ||
            !!errors.account ||
            !!getAccountError((_f = (_e = kycFields.withdrawal) === null || _e === void 0 ? void 0 : _e.account) !== null && _f !== void 0 ? _f : ""));
    var isUsdt0Blocked = isUsdt0 && (isExactOutUnsupported || !usdt0Chain);
    var isSubmitDisabled = Boolean(isSubmitting ||
        unsupportedAssetError ||
        isUsdt0Blocked ||
        isDepositDisabled ||
        isWithdrawalDisabled);
    if (unsupportedAssetError) {
        return (_jsx("div", { className: "FormContainer PageTransition", children: _jsx("div", { role: "alert", style: {
                    padding: "12px 16px",
                    backgroundColor: "#f8d7da",
                    color: "#721c24",
                    borderRadius: "4px",
                    border: "1px solid #f5c6cb",
                    width: "100%",
                }, children: unsupportedAssetError }) }));
    }
    return (_jsxs("form", { className: "FormContainer PageTransition", onSubmit: handleSubmitKyc, children: [type === "deposit" ? renderDepositFields() : null, type === "withdrawal" ? renderWithdrawFields() : null, isExactOutUnsupported && (_jsx("div", { role: "alert", style: {
                    padding: "12px 16px",
                    backgroundColor: "#f8d7da",
                    color: "#721c24",
                    borderRadius: "4px",
                    border: "1px solid #f5c6cb",
                    marginBottom: "16px",
                }, children: EXACT_OUT_UNSUPPORTED_MESSAGE })), submitError && (_jsx("div", { style: {
                    padding: "12px 16px",
                    backgroundColor: "#f8d7da",
                    color: "#721c24",
                    borderRadius: "4px",
                    border: "1px solid #f5c6cb",
                    marginBottom: "16px",
                }, children: submitError })), _jsx(Button, { type: "submit", className: "SubmitButton", disabled: isSubmitDisabled, children: _jsxs("span", { className: "SubmitButton__content", children: [isSubmitting ? _jsx("span", { className: "SubmitButton__spinner" }) : null, _jsx("span", { children: type === "deposit" ? "Deposit" : "Withdraw" })] }) })] }));
};
